<template>
  <el-collapse v-model="activeName">
    <el-collapse-item
      :key="item.name"
      v-for="(item,index) in  OrgOptions"
      :title="item.OrgianizationName"
      :name="item.PersonOrgianiztionId"
    >
      <UserListControl
        :ref="item.PersonOrgianiztionId"
        v-bind:ExecutId="ExecutId"
        :roomId="roomId"
        :pwd="pwd"
        :ResourceTypeId="ResourceTypeId"
        :PersonOrgianiztionId="item.PersonOrgianiztionId"
        :PersonName="PersonName"
      ></UserListControl>
      <el-divider v-if="index < OrgOptions.length - 1"></el-divider>
    </el-collapse-item>
  </el-collapse>
</template>
<script>
import MyApis from "../../../../apis";
import UserListControl from "./Component-UserListControl";
export default {
  components: {
    UserListControl
  },
  props: {
    ResourceTypeId: { type: String },
    PersonName: String,
    ExecutId: {
      type: String,
      required: true
    },
    roomId: {
      type: String
    },
    pwd: {
      type: String
    }
  },
  data() {
    return {
      ruleForm: {},
      OrgOptions: [],
      activeName: []
    };
  },
  created: function() {
    let that = this;
    new MyApis.PersonOrganiztionApi()
      .FindByConditions({
        ResourceTypeId: this.$props.ResourceTypeId,
        PageSize: 20,
        PageIndex: 1,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0
      })
      .then(r => {
        var data = r.data.Data;
        if (data && data.length > 0) {
          this.OrgOptions = data;
          for (let index = 0; index < data.length; index++) {
            that.activeName.push(data[index].PersonOrgianiztionId);
          }
        }
      })
      .catch(e => {
        console.log(e);
      });
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },

    GetUserIds() {
      var userids = [];
      for (var i = 0; i < this.OrgOptions.length; i++) {
        var item = this.OrgOptions[i];
        var chil = this.$refs[item.PersonOrgianiztionId][0];
        var usids = chil.Usersids;
        for (var j = 0; j < usids.length; j++) {
          userids.push(usids[0]);
        }
      }
      return userids;
    }
  }
};
</script>